import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackVirtualPageView } from "../utils/tracking";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  const isFirstRender = useRef(true);

  useEffect(() => {
    window.scrollTo(0, 0);

    // First load is counted by the GTM container itself; only SPA navigations need a push.
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    trackVirtualPageView(pathname);
  }, [pathname]);

  return null;
}